import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import i18n from "../../language/i18n";
import { normalizeLang } from "../../utils/localeDataLoader";
import { getHomeBanners } from "../../apis/homeBanners";
import defaultImg from "../../images/home1.jpg";
import { normalizeUploadedImageUrl } from "apis/uploadImage";

function Banner() {
  const { t } = useTranslation();
  const lang = normalizeLang(i18n.language);
  const isVietnamese = lang === "vi";
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let active = true;
    getHomeBanners(lang)
      .then((data) => {
        if (!active) return;
        if (Array.isArray(data) && data.length > 0) {
          setBanners(data);
        } else {
          setBanners([]);
        }
      })
      .catch(() => {
        if (active) setBanners([]);
      });
    return () => {
      active = false;
    };
  }, [lang]);

  const fallbackBanner = {
    id: "default-1",
    image: defaultImg,
    eyebrow:
      t("home.banner_subtitle") ||
      (isVietnamese
        ? "GIẢI PHÁP CÔNG NGHỆ - CHĂM SÓC SỨC KHỎE"
        : "TECHNOLOGY SOLUTIONS - HEALTHCARE"),
    title: t("home.banner_title") || "Healthcare Solution VIETNAM",
    lead: isVietnamese
      ? "Kiến tạo những giải pháp số thiết thực, kết nối con người và nâng tầm chất lượng cuộc sống."
      : "Building practical digital solutions that connect people and improve quality of life.",
    primaryButtonText: isVietnamese
      ? "Khám phá giải pháp"
      : "Explore solutions",
    primaryButtonUrl: "#home-solutions",
    secondaryButtonText: isVietnamese ? "Về chúng tôi" : "About us",
    secondaryButtonUrl: isVietnamese ? "/tong-quan" : "/about-us",
  };

  const list = banners.length > 0 ? banners : [fallbackBanner];
  const total = list.length;

  useEffect(() => {
    if (total <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 4000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <div className="banner banner-hero-slider">
      {list.map((item, idx) => {
        const isActive = idx === currentIndex;
        const bgImg = (lang === 'en' && item.imageEn) ? item.imageEn : (item.image || defaultImg);
        return (
          <div
            key={`slide-${item.id || idx}`}
            className={`banner-item background-img ${isActive ? "banner-item--active" : ""}`}
            style={{
              backgroundImage: `url(${normalizeUploadedImageUrl(bgImg)})`,
            }}
          >
            {isActive && (
              <div
                key={`content-${currentIndex}`}
                className="banner-item__content layout_container banner-item__content--animated"
              >
                {item.eyebrow && (
                  <p className="banner-item__eyebrow animate-fade-up-1">
                    {item.eyebrow}
                  </p>
                )}
                {item.title && (
                  <h2 className="animate-fade-up-2">{item.title}</h2>
                )}
                {item.lead && (
                  <p className="banner-item__lead animate-fade-up-3">
                    {item.lead}
                  </p>
                )}
                <div className="banner-item__actions animate-fade-up-4">
                  {item.primaryButtonText &&
                    (item.primaryButtonUrl?.startsWith("http") ? (
                      <a
                        className="banner-cta banner-cta--primary"
                        href={item.primaryButtonUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.primaryButtonText}
                      </a>
                    ) : (
                      <a
                        className="banner-cta banner-cta--primary"
                        href={item.primaryButtonUrl || "#home-solutions"}
                      >
                        {item.primaryButtonText}
                      </a>
                    ))}
                  {item.secondaryButtonText &&
                    (item.secondaryButtonUrl?.startsWith("http") ? (
                      <a
                        className="banner-cta banner-cta--ghost"
                        href={item.secondaryButtonUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.secondaryButtonText}
                      </a>
                    ) : (
                      <Link
                        className="banner-cta banner-cta--ghost"
                        to={
                          item.secondaryButtonUrl ||
                          (isVietnamese ? "/tong-quan" : "/about-us")
                        }
                      >
                        {item.secondaryButtonText}
                      </Link>
                    ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Banner;
